import { useState } from "react";
export var ScreenSize;
(function (ScreenSize) {
    ScreenSize["Large"] = "Large";
    ScreenSize["Medium"] = "Medium";
    ScreenSize["Small"] = "Small";
})(ScreenSize || (ScreenSize = {}));
;
const QUERIES = {
    [ScreenSize.Large]: window.matchMedia("(min-width: 1400px)"),
    [ScreenSize.Medium]: window.matchMedia("(min-width: 768px) and (max-width: 1399px)"),
    [ScreenSize.Small]: window.matchMedia("(max-width: 767px)"),
};
export function getScreenSize() {
    for (const screenSize of Object.values(ScreenSize)) {
        if (QUERIES[screenSize].matches) {
            return screenSize;
        }
    }
    return ScreenSize.Large;
}
let screenSize;
let setScreenSize;
export function useScreenSize() {
    return screenSize;
}
export function initScreenSize() {
    [screenSize, setScreenSize] = useState(getScreenSize());
    window.addEventListener('resize', () => {
        const currentScreenSize = getScreenSize();
        if (screenSize !== currentScreenSize) {
            setScreenSize(currentScreenSize);
        }
    });
}
//# sourceMappingURL=MediaQueries.js.map